<template>
	
<div class="default-panel">
	<div id="normalBar">
	    <mt-header :title="isAdd ? '新增地址':'编辑地址'" style="height: 50px">
	      <mt-button onClick= "history.back();" slot="left">
	        <img src="../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
	      </mt-button>
	       <mt-button slot="right">
	       	<span class="edite" @click="addSave" v-if="isEdite && isAdd">保存</span>
			<span class="edite" @click="editSave" v-if="isEdite && !isAdd">保存</span>
	       </mt-button>
	    </mt-header>
	    <hr style="height: 1px;background-color: #d8d8d8;"/>
  </div>
	

	<div class="address-edit-sec">
		<ul class="edit-list">
			<li>
				<div class="edit-item">
					<input type="text" class="input" v-model="name" v-bind:readonly="!isEdite" placeholder="收货人" maxlength="10">
				</div>
			</li>
			<li>
				<div class="edit-item">
					<input type="text" class="input" v-model="phone" maxlength="11" v-bind:readonly="!isEdite"
					placeholder="收货人手机" 
					/>
				</div>
			</li>
			<li>
				<div class="edit-item">
				<input type="text"  class="input" v-model="area" readonly="readonly"
					placeholder="收货城市"
					@click="isEdite ? popupVisible=true:''"
					/>
					<span class="icon-arrow-right"></span>
				</div>
			</li>
			<li>
				<div class="edit-item">
					<input type="text"  class="input" v-model="address" v-bind:readonly="!isEdite"
					placeholder="详细地址，如街道、楼层、门牌号等"
					/>
				</div>
			</li>
		</ul>
	</div>


	<mt-popup
 		v-model="popupVisible"
 		class="address-popup"
  		position="bottom">

  		<addressPick
  			:isOrderAddress = 'isOrderAddress'
  			v-on:cancel = "togglePopup"
  			v-on:submit = 'setAddressArea'
  		>
  		</addressPick>
	</mt-popup>



</div>

</template>

<script>
	import Vue from 'vue';
	import api from '@/api/api.js';
	import { CellSwipe } from '@/js/mint-ui';
	import { MessageBox } from '@/js/mint-ui';
	import { Cell } from '@/js/mint-ui';
	import { Popup } from '@/js/mint-ui';
	import { Picker } from '@/js/mint-ui';
	import { Toast } from '@/js/mint-ui';
	Vue.component(Picker.name, Picker);
	Vue.component(Popup.name, Popup);
	Vue.component(Cell.name, Cell);
	Vue.component(CellSwipe.name, CellSwipe);

	import normalBar from '@/components/common/navbar/normalBar'
	import addressPick from '@/components/common/Picker/addressPick'


	export default {
		data(){
			return {
				isAdd: true,//是否为添加
				name: '',
				phone: '',
				area: '',
				address: '',
				currRegionalismId:'',
				isEdite: true,

				isOrderAddress: false,
				
				popupVisible: false,
			    regionalismId:'',
			}
		},
		components: {
			normalBar,addressPick
		},
		created(){
			this.isOrderAddress = (this.$route.query.isOrderAddress===true || this.$route.query.isOrderAddress ==='true') ? true : false;

		},
		watch: {
			phone(val){
				this.phone = val.replace(/\D/g,'');
			}
		},
		mounted(){
			let self = this;
			let editId = this.$route.params.id;
				
			if(!!editId){
				this.$store.dispatch('getEditAddress',editId).then(function(res){
					var res = res.data;
					self.name = res.recipientName;
					self.phone =  res.recipientMobile;
					self.area =  res.regionalismName;
					self.address =  res.address;
					self.currRegionalismId = res.regionalismId;
					self.isEdite = true;
					self.isAdd = false;
				})
				
			}else {
				this.isEdite = true;
				this.isAdd = true;
			}
		},
		methods: {
			togglePopup(){
				this.popupVisible = !this.popupVisible;
			},
			setAddressArea(area){
    			this.area = area.pickerArea;
    			this.regionalismId = area.regionalismId;;
    			this.popupVisible = false;
    		},
			validAddress(type){
				let self = this;
				if(this.name == ''){
					Toast({
						message: '请填写收货人',
						duration: 1000
					});
					return false;
				} else if(this.phone=='' || this.phone.length != 11){
					Toast({
						message: '请正确填写收货人手机',
						duration: 1000
					});
					return false;
				}else if(this.area==''){
					Toast({
						message: '请选择城市',
						duration: 1000
					});
					return false;
				}else if(this.address==''){
					Toast({
						message: '请填写详情地址',
						duration: 1000
					});
					return false;
				}
				let params = {
					address: this.address,//	地址	number	
					recipientMobile: this.phone,//	收货人手机号	number	
					recipientName: this.name,//	收货人名字	number	
					regionalismId: this.regionalismId ? this.regionalismId : this.currRegionalismId//
				};

				if(type == 1){
					params.id = this.$route.params.id;
					this.$store.dispatch('editAddressSubmit',params).then(function(res){
						self.$route.query.url ? 
						self.$router.push({path: self.$route.query.url}):
						self.$router.push({path:'/addressList'});
					});

				}else {
					this.$store.dispatch('addAddressSubmit',params).then(function(res){
						self.$route.query.url ? 
						self.$router.push({path: self.$route.query.url}):
						self.$router.push({path:'/addressList'});
					});
				}
			},
			addSave(){
				this.validAddress(0);
			},
			editSave(){
				this.validAddress(1);
			},
		}
	}
</script>
<style lang="scss">
@import '../../assets/css/mixin';

.address-edit-sec {
	width: 100%;
}

.loginTips .edit-list {
	.edit-item {
		padding: pxToRem(50px)  pxToRem(60px) pxToRem(50px) 0;
		border-bottom: none;
	}
}

.edit-list {
	padding-left: pxToRem(50px);
	background-color: #fff;

	.edit-item {
		border-bottom: 1px solid #666666;
	}

	.edit-item  {
		display: flex;
		justify-content: space-between;
		padding: pxToRem(60px)  pxToRem(60px) pxToRem(30px) 0;
		&.no-bor {
			border: none;
		}

		.input {
			width: 100%;

			&.code-input {
				padding-bottom:  pxToRem(30px);
				width: 65%;
				border-bottom: 1px solid #666666;
			}

		}
		input::-webkit-input-placeholder {
			color: #BDBDBD;
		}
	}
}

.code {
	display: inline-block;
	border: 1px solid #666;
	color: #BDBDBD;
	background-color: #fff;
	width: pxToRem(180px);
	height: pxToRem(76px);

}

.btn-save {
	margin: pxToRem(100px) auto;
	display: block;
	width: 87%;
	height: pxToRem(100px);
	color: #fff;
	border: none;
	line-height: 1;
	font-size: pxToRem(28px);
	background-color: #D8331D;
}

.address-popup {
	width: 100%;
}
.picker-items {
	width: 100%;
}

.flex-bar {
	padding: 0 pxToRem(30px);
	display: flex;
	justify-content: space-around;
	height: pxToRem(100px);
	line-height: pxToRem(100px);
	border-bottom: 1px solid #eee;
	.flex-right,.flex-left{
		width: pxToRem(60px);
	}
}

.flex-title {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	background-color: rgba(255,255,255,0.90);
}
.edite {
	display: inline-block;
	width: pxToRem(60px);
	color: #666;
}
	
</style>


// WEBPACK FOOTER //
// addressEdit.vue?3c0daaf2